import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/historico-operacao")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/historico" });
  },
});
